import Product from '../../../product';

export default class BaseCollection {
  /**
   * Array collection products
   * @type {[Product]}
   */
  products = [];

  /**
   * @type {Total}
   */
  total;

  /**
   * @param {Total} total
   */
  constructor(total) {
    this.total = total;
  }

  /**
   * @param {number} id
   * @returns {BaseCollection}
   */
  removeById(id) {
    const index = this.findIndexById(id);
    const product = this.products[index];
    if (product !== undefined) {
      this.products.splice(index, 1);
      this.decrease(product);
      this.total.updateSummary();
    }
    return this;
  }

  /**
   * Paste product element
   * @param {Element} el
   * @returns {BaseCollection}
   */
  addByEl(el) {
    const product = new Product(el);
    this.products.push(product);
    this.increase(product);
    this.total.updateSummary();
    return this;
  }

  /**
   * @param {number} id
   * @returns {number}
   */
  findIndexById(id) {
    return this.products.findIndex(product => product.id === id);
  }

  /**
   * Clear BaseCollection
   * @returns {BaseCollection}
   */
  remove() {
    this.products = [];
    this.total.Sum = 0;
    this.total.Count = 0;
    this.total.Price = 0;
    return this;
  }

  /**
   * @param {Product} product
   * @returns {BaseCollection}
   */
  increase(product) {
    this.total.Sum += product.sum;
    if (product.wish) {
      this.total.Count += product.count;
      this.total.Price += product.sum; // пока одно и то же
    }
    return this;
  }

  /**
   * @param {Product} product
   * @returns {BaseCollection}
   */
  decrease(product) {
    this.total.Sum -= product.sum;
    if (product.wish) {
      this.total.Count -= product.count;
      this.total.Price -= product.sum; // пока одно и то же
    }
    return this;
  }

  /**
   * @param {number} id
   * @param {boolean} selected - Product.selected checkbox (push product to order)
   * @returns {BaseCollection}
   */
  changeTotal(id) {
    const product = this.products[this.findIndexById(id)];

    if (product !== undefined) {
      this.decrease(product);
      product.update();
      this.increase(product);
      this.total.updateSummary();
    }
    return this;
  }
}
